import React from 'react';
import { Bot } from 'lucide-react';

const STATE_CLS = {
    open: 'border-emerald-400/50 bg-emerald-500/10 text-emerald-100',
    pending: 'border-amber-400/50 bg-amber-500/10 text-amber-100',
    closed: 'border-sky-400/40 bg-sky-500/10 text-sky-100',
    skip: 'border-slate-600 bg-slate-800 text-slate-300',
    block: 'border-slate-700 bg-slate-800/60 text-slate-400',
    none: 'border-slate-700 bg-slate-800/60 text-slate-400',
};

/** 🤖 Her coinin yanında botun durumu: açtı / tetik bekliyor / bugün kapandı / açmadı: sebep / bot kapalı. */
export default function BotStatusChip({ bot, block, actionable, symbol, size = 'sm' }) {
    let state; let text;
    if (bot) { state = bot.state; text = bot.text; }
    else if (block) { state = 'block'; text = block; }
    else if (actionable) { state = 'none'; text = 'bot değerlendiriyor…'; }
    else return null;
    const pad = size === 'lg' ? 'px-2 py-1 text-xs' : 'px-1.5 py-0.5 text-[11px]';
    return (
        <span className={`inline-flex items-center gap-1 rounded-md border font-semibold ${pad} ${STATE_CLS[state] || STATE_CLS.none}`}
              data-testid={`bot-status-${symbol}`} data-state={state} title="Otomatik botun bu coin için durumu">
            <Bot className="h-3 w-3 shrink-0" /> {text}
        </span>
    );
}
